export default __webpack_public_path__ + "static/media/AdSpace_01.0038b45b.png";